function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { fontSemiBold } from '../theme/fonts';
import { size4, size8, size12, size14, size32 } from '../theme/scale';
import { white, gray700, teal600, red500, blue600, primary600, teal100, teal800 } from '../theme/colors';
export const CHIP_FILLS = {
  gray: {
    background: gray700,
    color: white
  },
  teal: {
    background: teal600,
    color: white
  },
  red: {
    background: red500,
    color: white
  },
  blue: {
    background: blue600,
    color: white
  },
  primary: {
    background: primary600,
    color: white
  },
  'teal-inverse': {
    background: teal100,
    color: teal800
  }
};
export const CHIP_VARIANTS = {
  gray: {
    color: gray700,
    'border-color': gray700
  },
  teal: {
    color: teal600,
    'border-color': teal600
  },
  red: {
    color: red500,
    'border-color': red500
  },
  blue: {
    color: blue600,
    'border-color': blue600
  },
  primary: {
    color: primary600,
    'border-color': primary600
  },
  'teal-inverse': {
    color: teal800,
    'border-color': teal100
  }
};
export const CHIP_SIZES = {
  sm: {
    'font-size': size12,
    padding: `${size4} ${size8}`
  },
  md: {
    'font-size': size14,
    padding: `${size8} ${size14}`
  }
};
const ChipWrapper = styled.div`
  background: transparent;
  border: 1px solid;
  display: inline-flex;
  font-family: ${fontSemiBold};
  width: fit-content;
  border-radius: ${({
  rounded
}) => rounded ? size32 : size4};
  text-transform: ${({
  textCase
}) => textCase};
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size8};`}
  ${({
  variant
}) => ({
  ...CHIP_VARIANTS[variant]
})}
  ${({
  size
}) => ({
  ...CHIP_SIZES[size]
})}
  ${({
  filled,
  variant
}) => filled && {
  ...CHIP_FILLS[variant]
}}
`;
export const Chip = ({
  message,
  variant = 'gray',
  size = 'sm',
  filled = false,
  rounded = true,
  marginBottom = false,
  textCase = 'uppercase',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ChipWrapper, _extends({
    textCase,
    variant,
    size,
    filled,
    rounded,
    marginBottom
  }, props), message);
};
export default Chip;
//# sourceMappingURL=index.js.map